export const variables = {
    //API_URL: "https://localhost:7100/api/",
    API_URL: "https://api.nexusprimeind.com/api/",
    //projectImgPath: "https://localhost:7100",
    projectImgPath: "https://api.nexusprimeind.com"
};


export const validEmail = new RegExp(
    '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'
);